import { useTranslation } from 'react-i18next';
import TrophyBadge from './TrophyBadge';
import {
  Card,
  CardTopRow,
  CardTrophyColumn,
  CardContentColumn,
  CardInfoRow,
  CardInfoColumn,
  CardLevelText,
  CardCategoryName,
  CardCounter,
  CardProgressBar,
  CardProgressFill,
} from './styled-components';

const CategoryCard = ({ category }) => {
  const { t } = useTranslation('gamification');
  const progressValue = category.total > 0
    ? (category.acquired / category.total) * 100
    : 0;

  return (
    <Card>
      <CardTopRow>
        <CardTrophyColumn>
          <TrophyBadge
            categoryId={category.id}
            trophyColor={category.currentLevelKey}
          />
        </CardTrophyColumn>
        <CardContentColumn>
          <CardInfoRow>
            <CardInfoColumn>
              <CardLevelText>
                {t('levelPrefix')} {category.currentLevelOrder}
              </CardLevelText>
              <CardCategoryName>{category.name}</CardCategoryName>
            </CardInfoColumn>
            <CardCounter>{category.acquired}/{category.total}</CardCounter>
          </CardInfoRow>
          <CardProgressBar>
            <CardProgressFill $width={Math.min(progressValue, 100)} />
          </CardProgressBar>
        </CardContentColumn>
      </CardTopRow>
    </Card>
  );
};

export default CategoryCard;
